// import React, { useEffect, useRef } from 'react';
// import './analytics.css';
// import PageContainer from 'src/components/container/PageContainer';

// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
// } from 'chart.js';
// import {
//   Button,
//   FormControl,
//   MenuItem,
//   Select,
// } from '@mui/material';
// import { useMain } from 'src/views/hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import LineGraph from './LineGraph';
// import BarGraph from './BarGraph';
// import * as XLSX from 'xlsx';
// import { FaDownload } from 'react-icons/fa';
// import {
//   setFilterParams,
//   setSalesData,
//   setPackageMembershipData,
//   setStaffGraphData,
//   calculateTotals,
//   setLoading,
//   setLoadingCurrentYear
// } from '../../../redux/slices/salesAnalyticsSlice';
// import { useDispatch, useSelector } from 'react-redux';
// import CashCollectionReport from './CashCollectionReport';
// import { changeDateFormate, changeTimeFormate } from 'src/utils/dateutils';
// ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

// const filterOptions = [
//   { label: 'Current Year', value: 'Current Year' },
//   { label: 'Current Month', value: 'Current Month' },
//   { label: 'Current Week (Sun-Sat)', value: 'Current Week' },
//   { label: 'Today', value: 'Today' },
//   { label: 'Custom Date', value: 'customDate' },
// ];

// export const maskData = (value, isMasked) => {
//   if (isMasked) {
//     const maskLength = Math.ceil(value.length / 2);
//     return '*'.repeat(maskLength) + value.substring(maskLength);
//   } else {
//     return value;
//   }
// };

// function SalesReport() {
//   const dispatch = useDispatch();
//   const tableRef = useRef();
//   const { activeBranchId, fetchBillAnalytics, branchData, staffCollection, fetchPackageAndMembershipBills } =
//     useMain();

//   // Get state from Redux
//   const {
//     filterBy,
//     from,
//     to,
//     tableData,
//     graphData,
//     staffGraphData,
//     cashData,
//     packagedata,
//     memberdata,
//     advance,
//     totalWithoutWallet,
//     totals,
//     loading,
//     loadingCurrentYear,
//     selectedView,
//     expenses
//   } = useSelector((state) => state.salesAnalytics);


//   const fetchData = async () => {
//     const queryParams = `?filterBy=${filterBy}${from ? `&startDate=${from}` : ''}${to ? `&endDate=${to}` : ''}`;

//     try {
//       if (filterBy === 'Current Year') {
//         dispatch(setLoadingCurrentYear(true));
//       } else {
//         dispatch(setLoading(true));
//       }

//       // Fetch all data in parallel
//       const [analyticsRes, packageRes, staffRes] = await Promise.all([
//         fetchBillAnalytics(activeBranchId, queryParams),
//         fetchPackageAndMembershipBills(activeBranchId, `&filterBy=${filterBy}${from ? `&startDate=${from}` : ''}${to ? `&endDate=${to}` : ''}`),
//         staffCollection(activeBranchId, queryParams)
//       ]);

//       if (analyticsRes.statusCode === 200) {
//         dispatch(setSalesData({
//           tableData: analyticsRes.data.salesData.billDetails,
//           graphData: {
//             labels: analyticsRes.data.salesData.labels,
//             data: analyticsRes.data.salesData.data
//           },
//           cashData: analyticsRes.data.paymentTypeWiseAmount,
//           advance: analyticsRes.data.totalAdvanceAmount,
//           expenses: analyticsRes.data.totalExpense
//         }));
//         dispatch(calculateTotals());
//       }

//       if (packageRes.statusCode === 200) {
//         dispatch(setPackageMembershipData({
//           packagedata: packageRes.data?.packageBills,
//           memberdata: packageRes.data?.membershipBills
//         }));
//       }

//       if (staffRes.statusCode === 200) {
//         dispatch(setStaffGraphData({
//           categories: staffRes.data.staffName.map(item => item || ''),
//           series: staffRes.data.totalStaffSales
//         }));
//       }
//     } finally {
//       if (filterBy === 'Current Year') {
//         dispatch(setLoadingCurrentYear(false));
//       } else {
//         dispatch(setLoading(false));
//       }
//     }
//   };

//   const handleApply = () => {
//     dispatch(setFilterParams({ filterBy, from, to }));
//     fetchData();
//   };

//   const handleOnExport = () => {
//     if (!Array.isArray(tableData)) return;

//     const flattenedData = tableData.map((item) => ({
//       ...item,
//       serviceName: item.services?.map(s => s.serviceName).join(', ') || '',
//       serviceProviders: item.services?.map(s => s.serviceProvider?.name).join(', ') || '',
//       productName: item.products?.map(p => p.productName).join(', ') || '',
//       productProvider: item.products?.map(p => p.providerStaff?.name).join(', ') || ''
//     }));

//     const wb = XLSX.utils.book_new();
//     const ws = XLSX.utils.json_to_sheet(flattenedData);
//     XLSX.utils.book_append_sheet(wb, ws, 'Bills');
//     XLSX.writeFile(wb, 'Bills.xlsx');
//   };

//   useEffect(() => {
//     if (activeBranchId) {
//       fetchData();
//     }
//   }, [activeBranchId]);

//   return (
//     <>
//       <PageContainer title="Sales Report" description="This is Sales Analytics">
//         {loading || (filterBy === 'Current Year' && loadingCurrentYear) ? (
//           <ShowLoader />
//         ) : (
//           <>
//             <div
//               style={{
//                 marginLeft: filterBy === 'customDate' ? '28.3rem' : '50rem',
//                 marginTop: '-3rem',
//               }}
//             >
//               <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
//                 <div
//                   style={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     alignItems: 'flex-start',
//                     marginLeft: '1.6rem',
//                   }}
//                 >
//                   <div style={{ fontWeight: 'bold' }}>Filter By:</div>
//                   <FormControl fullWidth>
//                     <Select
//                       name="Filter Options"
//                       onChange={(e) => dispatch(setFilterParams({ filterBy: e.target.value, from, to }))}
//                       value={filterBy}
//                       sx={{ height: '36px', fontSize: '0.875rem', width: '200px' }}
//                     >
//                       {filterOptions?.map((sourceOption) => (
//                         <MenuItem key={sourceOption.value} value={sourceOption.value}>
//                           {sourceOption.label}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </div>

//                 {filterBy === 'customDate' && (
//                   <div style={{ display: 'flex', gap: '1rem' }}>
//                     <div>
//                       <div style={{ marginBottom: '3px', fontWeight: 'bold' }}>From</div>
//                       <input
//                         type="date"
//                         className="form-control"
//                         style={{ padding: '8px', height: '36px' }}
//                         name="from"
//                         onChange={(e) => dispatch(setFilterParams({ filterBy, from: e.target.value, to }))}
//                         value={from}
//                       />
//                     </div>
//                     <div>
//                       <div style={{ marginBottom: '3px', fontWeight: 'bold' }}>To</div>
//                       <input
//                         type="date"
//                         max={new Date().toISOString().split('T')[0]}
//                         className="form-control"
//                         style={{ padding: '8px', height: '36px' }}
//                         name="to"
//                         onChange={(e) => dispatch(setFilterParams({ filterBy, from, to: e.target.value }))}
//                         value={to}
//                       />
//                     </div>
//                   </div>
//                 )}

//                 <div style={{ display: 'flex', alignItems: 'flex-end', marginTop: '1rem' }}>
//                   <Button
//                     disabled={!!(filterBy === 'customDate' && (from === '' || to === ''))}
//                     variant="contained"
//                     color="primary"
//                     sx={{
//                       background: '#6174DD',
//                       padding: '8px 16px',
//                       fontSize: '0.875rem',
//                     }}
//                     onClick={handleApply}
//                   >
//                     Apply
//                   </Button>
//                 </div>
//               </div>
//             </div>

//             {tableData.length !== 0 ? (
//               <>
//                 {
//                 !branchData?.hideDownloadButton && (
//                     <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '4rem',marginRight:'2rem' }}>
//                   <button title="Download Excel File" className="view-btn" style={{ marginTop: '2rem' }} onClick={handleOnExport}>
//                     <FaDownload style={{ height: '1.4rem', fontSize: '1.8rem' }} />
//                   </button>
//                 </div>
//                 )
//               }
//                 {/* <div style={{display:"flex",justifyContent:"space-evenly", gap:"10rem"}}> */}
//                 <div
//                   style={{
//                     marginTop: '5rem',
//                     display: 'flex',
//                     justifyContent: 'space-evenly',
//                     gap: '6rem',
//                   }}
//                 >
//                   <div>
//                     <LineGraph graphData={graphData} />
//                   </div>
//                   <CashCollectionReport
//                     cashData={cashData}
//                     totalWithoutWallet={totalWithoutWallet}
//                     taxAmount={totals.taxAmount}
//                     dueAmount={totals.dueAmount}
//                     advance={advance}
//                     packagedata={packagedata}
//                     memberdata={memberdata}
//                     expenses={expenses}
//                   />
//                 </div>

//                 <div className="chart-container">
//                   <div>
//                     <h4
//                       style={{
//                         textAlign: 'center',
//                         fontSize: '16px',
//                         color: 'green',
//                         fontWeight: 'bold',
//                         marginTop: '50px',
//                       }}
//                     >
//                       Staff Collection Report{' '}
//                     </h4>
//                     <BarGraph data={staffGraphData} />
//                   </div>
//                 </div>

//                 <table className="table-container mt-3" ref={tableRef}>
//                   <thead className="table-thead">
//                     <tr>
//                       {[
//                         'Date of Bill',
//                         'Time of Bill',
//                         'Client Name',
//                         'Contact',
//                         'Total',
//                         'Paid',
//                         'Pending',
//                       ].map((h, index) => {
//                         return (
//                           <th key={index} style={{ width: '100%' }}>
//                             {h}
//                           </th>
//                         );
//                       })}
//                     </tr>
//                   </thead>
//                   <tbody className="table-tbody">
//                     {tableData.map((item) => {
//                       return (
//                         <tr key={item._id}>
//                           <td style={{ width: '100%' }}>
//                             {changeDateFormate(item?.dateOfBilling)}
//                           </td>
//                           <td style={{ width: '100%' }}>{changeTimeFormate(item?.timeOfBilling)}</td>
//                           <td style={{ width: '100%' }}>{item?.clientName}</td>
//                           <td style={{ width: '100%' }}>
//                             {typeof branchData?.isMasked !== 'boolean' || !item?.clientNumber
//                               ? 'loading...'
//                               : maskData(item?.clientNumber, branchData?.isMasked)}
//                           </td>
//                           <td style={{ width: '100%' }}>{item?.amountPayable}</td>
//                           <td style={{ width: '100%' }}>
//                             {item?.amountPaid
//                               .reduce((acc, payment) => acc + parseFloat(payment.amount), 0)
//                               .toString()}
//                           </td>

//                           <td style={{ width: '100%' }}>{item?.paidDues || 0}</td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </>
//             ) : (
//               <p>No bills are available for the selected time interval.</p>
//             )}
//           </>
//         )}
//       </PageContainer>
//     </>
//   );
// }

// export default SalesReport;


import React, { useRef } from 'react';
import './analytics.css';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Grid, Box, Typography } from '@mui/material';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import { useMain } from 'src/views/hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import LineGraph from './LineGraph';
import BarGraph from './BarGraph';

import { useSelector } from 'react-redux';
import CashCollectionReport from './CashCollectionReport';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);


export const maskData = (value, isMasked) => {
  if (isMasked) {
    const maskLength = Math.ceil(value.length / 2);
    return '*'.repeat(maskLength) + value.substring(maskLength);
  } else {
    return value;
  }
};

function SalesReport() {
  const { branchData } = useMain();
  const tableRef = useRef();

  // Get state from Redux
  const {
    filterBy,
    tableData,
    graphData,
    staffGraphData,
    cashData,
    packagedata,
    memberdata,
    advance,
    totalWithoutWallet,
    totals,
    loading,
    loadingCurrentYear,
    expenses
  } = useSelector((state) => state.salesAnalytics);

  const staffCount = staffGraphData?.categories?.length || 0;

  return (
    <>
        {loading || (filterBy === 'Current Year' && loadingCurrentYear) ? ( 
          <ShowLoader />
        ) : (
          <>
            {tableData.length !== 0 ? (
              <>
              <Grid container spacing={3} sx={{ mt: 1 }}>
                <Grid item xs={12}>
                  <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
                    Cash Collection
                  </Typography>
                  <CashCollectionReport
                    cashData={cashData}
                    totalWithoutWallet={totalWithoutWallet}
                    taxAmount={totals.taxAmount}
                    dueAmount={totals.dueAmount}
                    advance={advance}
                    packagedata={packagedata}
                    memberdata={memberdata}
                    expenses={expenses}
                    billDetails={tableData}
                  />
                </Grid>
                <Grid item xs={12}>
                  <DashboardCard2 title="Bill Report">
                    <LineGraph graphData={graphData} />
                  </DashboardCard2>
                </Grid>
                {staffCount > 0 && (
                  <Grid item xs={12} sx={{ mt: 2 }}>
                    <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
                      Staff Collection Report
                    </Typography>
                    <BarGraph data={staffGraphData} />
                  </Grid>
                )}
              </Grid>

                <table className="table-container mt-3" ref={tableRef}>
                  <thead className="table-thead">
                    <tr>
                      {[
                        'Date of Bill',
                        'Time of Bill',
                        'Client Name',
                        'Contact',
                        'Total',
                        'Paid',
                        'Pending',
                      ].map((h, index) => {
                        return (
                          <th key={index} style={{ minWidth: h === 'Date of Bill' ? '120px' : 'auto' }}>
                            {h}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody className="table-tbody">
                      {tableData.map((item) => {
                       const originalDate = item?.dateOfBilling;
                       let formattedBillDate = '';
                       if (originalDate) {
                         const [year, month, day] = originalDate.split('-');
                         formattedBillDate = `${day}-${month}-${year}`;
                        };
                        let [hours, minutes] = item?.timeOfBilling.split(':').map(Number);
                        const postfix = hours >= 12 ? 'PM' : 'AM';

                        hours = hours % 12 || 12; // convert 0 or 12 to 12

                        let formattedBillTime = `${hours}:${minutes
                          .toString()
                          .padStart(2, '0')} ${postfix}`;
                      return (
                        <tr key={item._id}>
                          <td style={{ width: '100%' }}>{formattedBillDate}</td>
                          <td style={{ width: '100%' }}>{formattedBillTime}</td>
                          <td style={{ width: '100%' }}>{item?.clientName}</td>
                          <td style={{ width: '100%' }}>
                            {typeof branchData?.isMasked !== 'boolean' || !item?.clientNumber
                              ? 'loading...'
                              : maskData(item?.clientNumber, branchData?.isMasked)}
                          </td>
                          <td style={{ width: '100%' }}>{item?.amountPayable}</td>
                          <td style={{ width: '100%' }}>
                            {item?.amountPaid
                              .reduce((acc, payment) => acc + parseFloat(payment.amount), 0)
                              .toString()}
                          </td>

                          <td style={{ width: '100%' }}>{item?.paidDues || 0}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </>
            ) : (
              <p>No bills are available for the selected time interval.</p>
            )}
          </>
        )}
    </>
  );
}

export default SalesReport;